import { render, staticRenderFns } from "./BlockPanel.vue?vue&type=template&id=e3eeb814&"
import script from "./BlockPanel.vue?vue&type=script&lang=js&"
export * from "./BlockPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports